export const has = <K extends string>(key: K, x: Record<string, unknown>): x is { [key in K]: unknown } => key in x;

export function isNode(e: EventTarget | null): e is Node {
  return e && 'nodeType' in e;
}
